'use client';
export * from 'swr';
export { default as useSWR, SWRConfig } from 'swr';
export { default as useSWRInfinite } from 'swr/infinite';
